import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_8: FaireProductEntity = {
  token: "sweet-wink-8",
  type: "product",
  name: "Bomb Pop Short Sleeve Tutu Bodysuit - 4th of July - Baby",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/2219cc77c5135b7d23e6fb8c68c6f8ad985d55ee82d089c9b93adf926a1858c1.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 16,
  msrpDollars: 32,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
